import useHighlightStore, { ItemType } from "../zstore/highlightStore";
import useMessage from "./useMessage";
import { first } from "lodash";
import { scrollTo } from "../utils/dom";

type Options<T> = {
  results: T[];
  idProps?: keyof T | "id";
  msg: string;
  scroll: boolean;
  type: (typeof ItemType)[keyof typeof ItemType];
}

const useCheckResult = () => {
  const addHighlightItems = useHighlightStore((state) => state.batchAddItem);
  const message = useMessage();
  return <T>({ results, idProps = "id", msg, scroll, type }: Options<T>) => {
    if (!results || results.length === 0) {
      return;
    }
    if (msg) {
      message.info({
        content: msg,
        style: {
          marginTop: "45vh"
        }
      });
    }
    const highlightItems = results.map((el) => ({
      ...el,
      id: el[idProps as keyof T] as string,
      type: type
    }));
    addHighlightItems(highlightItems);
    if (scroll) {
      const firstError = first(highlightItems);
      scrollTo(firstError!.id, { block: "center" });
    }
  };
};

export default useCheckResult;
